/*
  Kiwi Ears · Shop by Sound page behaviours (Rene 2026-08-30).

  Two small jobs, both loaded by more than one section, so the file carries a
  run-once guard: a <script src> executes once per TAG, and sn-hero and
  sn-picks both reference this one.

  1. THE ROTATOR. One line under the hero copy that cycles short phrases.
     Gated on prefers-reduced-motion, and the first phrase ships in the markup
     — with no JS and no motion the line still reads, it just stops changing.
     Text goes in via textContent: these phrases are merchandiser copy, not
     markup.

  2. VARIATION → PRODUCT GROUP. Picking one of sn-profiles' variation cards
     dims the product groups in sn-picks that do not match it. The link is by
     HANDLE — the variation card's own title, handleized, against the group's
     title, handleized — so nobody has to keep a pair of ids in step by hand;
     naming the group the same as the variation is the whole contract.

     Both sides are optional. sn-profiles also runs on four scenario pages that
     have no sn-picks at all, so a page with no groups (or no match) simply
     leaves every group at full strength rather than dimming all of them,
     which would read as a bug.
*/
(function () {
  if (window.__kiwiSoundPage) return;
  window.__kiwiSoundPage = true;

  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function handleize(s) {
    return String(s || '').toLowerCase().trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  /* ------------------------------------------------------------ rotator */
  function armRotator() {
    if (still) return;
    [].slice.call(document.querySelectorAll('[data-sn-rotator]')).forEach(function (host) {
      var out = host.querySelector('[data-sn-rottext]');
      if (!out) return;
      var phrases = (host.getAttribute('data-phrases') || '').split('|')
        .map(function (p) { return p.trim(); })
        .filter(Boolean);
      if (phrases.length < 2) return;   /* nothing to rotate to */
      var i = 0;
      setInterval(function () {
        /* pause while the tab is hidden — a timer nobody can see is just
           wasted wakeups on a phone */
        if (document.hidden) return;
        out.classList.add('is-out');
        setTimeout(function () {
          i = (i + 1) % phrases.length;
          out.textContent = phrases[i];
          out.classList.remove('is-out');
        }, 220);
      }, 2600);
    });
  }

  /* ------------------------------------------ variation → product group */
  function armGroups() {
    var cards = [].slice.call(document.querySelectorAll('#sn-profiles .sn-profile'));
    var groups = [].slice.call(document.querySelectorAll('[data-sn-group]'));
    if (!cards.length || !groups.length) return;

    /* data-profile is the card's own title, already on the button — read that
       rather than digging for an h3, which is markup this file does not own. */
    function label(card) {
      return handleize(card.getAttribute('data-profile') || (card.querySelector('h3') || {}).textContent);
    }
    /* Only wire up if at least one card actually names a group. Otherwise the
       first click would dim every group and nothing would come back. */
    var names = groups.map(function (g) { return g.getAttribute('data-sn-group'); });
    var matched = cards.some(function (c) { return names.indexOf(label(c)) > -1; });
    if (!matched) return;

    function paint(target) {
      groups.forEach(function (g) {
        var on = g.getAttribute('data-sn-group') === target;
        g.classList.toggle('is-on', on);
        g.classList.toggle('is-off', !on);
      });
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        var t = label(card);
        if (names.indexOf(t) === -1) return;   /* card names no group: leave as is */
        paint(t);
      });
    });

    /* NO initial paint (Rene 2026-08-31): a card is pressed on load, so this
       dimmed groups 2 and 3 before the visitor had chosen anything — it read
       as "these are lesser", not as a filter. Dimming is now strictly a
       response to a click. */
  }

  function arm() { armRotator(); armGroups(); }
  if (document.readyState !== 'loading') arm();
  else document.addEventListener('DOMContentLoaded', arm);
})();
